import React from 'react';

export const FollowingIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path d="M13.121,13.8 L11.707,15.21 L8.879,12.38 L10.293,10.97 L11.5,12.18 L14.121,9.55 L15.536,10.97 L16,11.09 L13.121,13.8 Z M6.5,9.44 C4.1,9.44 3.2,7.09 3,5.16 C2.7,2.79 3.9,0.99 6.5,0.99 C9.1,0.99 10.3,2.79 10,5.16 C9.8,7.09 8.9,9.44 6.5,9.44 L6.5,9.44 Z M3.7,9.05 C4.43300606,9.81045069 5.44378831,10.2400519 6.5,10.2400519 C7.55621169,10.2400519 8.56699394,9.81045069 9.3,9.05 C9.52142291,9.17836953 9.7561323,9.28231226 10,9.36 L10,10.09 L8,10.09 L8,14.09 L9,14.09 L9,15.09 L10,15.09 L10,16.09 L11,16.09 L11,16.23 C10.768,16.29 10.536,16.35 10.3,16.39 C7.80460277,17.0100155 5.19539723,17.0100155 2.7,16.39 C2.05281138,16.2719791 1.41709112,16.0979925 0.8,15.87 C0.3,15.69 5.76238718e-14,15.62 5.76238718e-14,15.04 C-0.000151022392,14.2833085 0.100740541,13.5299848 0.3,12.8 C0.299276605,11.7640966 0.69252171,10.7666841 1.4,10.01 C1.90946697,9.73868565 2.44565985,9.52085729 3,9.36 C3.2438677,9.28231226 3.47857709,9.17836953 3.7,9.05 Z"/>
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/following-icon.js